export default "__VITE_ASSET__CuBZ6rsx__"